import { createFileRoute, Link } from '@tanstack/react-router';

import { DomainsScreen } from '../../features/settings/domains-screen';
import { SETTINGS_PERMISSIONS } from '../../features/settings/types';
import { RequirePermission } from '../../lib/session/guards';

export const Route = createFileRoute('/settings/domains')({
  component: DomainsPage,
});

/** `/settings/domains` — the addresses patients reach the clinic at (M11.5, FR-PLAT-02). */
function DomainsPage() {
  return (
    <RequirePermission keys={[SETTINGS_PERMISSIONS.domainsManage]}>
      <DomainsScreen
        backLink={
          <Link
            to="/settings"
            className="inline-block min-h-6 text-primary-accessible underline underline-offset-4"
          >
            Settings
          </Link>
        }
      />
    </RequirePermission>
  );
}
